import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {forkJoin, map, Observable} from 'rxjs';

import {Dimension, DimensionItem} from '@selpia/shared/models';

@Injectable({
  providedIn: 'root',
})
export class DimensionItemsService {
  readonly #http: HttpClient = inject(HttpClient);
  readonly #url: string = S2WX_API_URL + '/Dimensions';

  loadAll(dimensions: Dimension[]): Observable<Map<string, DimensionItem[]>> {
    return forkJoin(this.#loadItemsFor(dimensions))
      .pipe(
        map((itemsByDimension: DimensionItem[][]) => {
          const dimensionItemsMap = new Map();
          dimensions.forEach((dimension, i) => {
            dimensionItemsMap.set(
              dimension.name,
              this.#enrichItemsWithDimensionAndLevel(itemsByDimension[i], dimension),
            );
          });
          return dimensionItemsMap;
        }),
      );
  }

  #loadItemsFor(dimensions: Dimension[]): Observable<DimensionItem[]>[] {
    return dimensions.map((dimension) =>
      this.#http.get<DimensionItem[]>(`${this.#url}/${dimension.name}/items`),
    );
  }

  #enrichItemsWithDimensionAndLevel(items: DimensionItem[], dimension: Dimension): DimensionItem[] {
    return items
      .map(item => {
        const dimensionLevel = dimension.levels.find(level => level.name === item.dimensionLevelName);
        if (!dimensionLevel) {
          console.error('no dimension LEVEL match for DimensionItem');
          return ({...item, dimension});
        }
        return ({...item, dimension, dimensionLevel});
      });
  }
}
